import { useState } from 'react';
import { Button, Card, CardContent, CardHeader, Tab, Tabs } from '@mui/material';

import { TabPanel } from '../../components/tab-panel';
import { LeaveRequestsComponent } from './leave-requests.component';
import { LeaveApprovalComponent } from './leave-approval.component';
import { GuardedComponent } from '../../components/guarded-component';
import { UserPermissionName } from '../../models/user-permission-name';
import { useAuthorize } from '../../hooks/use-authorize';

const styling = {
  tabHeading: { fontWeight: 'bold' },
};

interface LeaveManageComponent {
  onEditLeave: (data: any) => void;
  dialogAction: (data: string) => void;
}
export const LeaveManageComponent = ({ dialogAction, onEditLeave }: LeaveManageComponent) => {
  const hasApproveLeavePermission = useAuthorize([UserPermissionName.APPROVE_LEAVE]);
  const hasRejectPermission = useAuthorize([UserPermissionName.REJECT_LEAVE]);
  const [value, setValue] = useState(!hasApproveLeavePermission && !hasRejectPermission ? 'request' : 'approval');
  const handleTabsChange = (event: any, value: any) => {
    setValue(value);
  };

  return (
    <Card>
      <CardHeader
        style={{ paddingBottom: '0' }}
        title={
          <Tabs value={value} onChange={handleTabsChange}>
            <Tab
              hidden={!hasApproveLeavePermission && !hasRejectPermission}
              value="approval"
              label={<div style={styling.tabHeading}>LEAVE APPROVAL</div>}
            />
            <Tab value="request" label={<div style={styling.tabHeading}>LEAVE REQUESTS</div>} />
          </Tabs>
        }
        action={
          <GuardedComponent requiredPermissions={[UserPermissionName.ADD_LEAVE]}>
            <Button
              style={{ marginTop: '10px', marginRight: '10px' }}
              size="small"
              variant="contained"
              disableElevation={true}
              onClick={() => dialogAction(value)}
            >
              APPLY FOR LEAVE
            </Button>
          </GuardedComponent>
        }
      />
      <CardContent style={{ paddingTop: '0' }}>
        {(hasApproveLeavePermission || hasRejectPermission) && (
          <TabPanel selectedValue={value} value="approval">
            <LeaveApprovalComponent />
          </TabPanel>
        )}
        <TabPanel selectedValue={value} value="request">
          <LeaveRequestsComponent onEditLeave={onEditLeave} />
        </TabPanel>
      </CardContent>
    </Card>
  );
};
